import type { IBuzzBridgeConfig } from '../types/global/helper';
import { isBrandPlatformAutoLinkEnabled } from './brandSocialAutoLink';

export type CreatorSocialPlatformId = 'instagram' | 'tiktok' | 'youtube';

/** True when OAuth auto-link is enabled for this creator platform (default: enabled). */
export function isInfluencerPlatformAutoLinkEnabled(
    config: IBuzzBridgeConfig | undefined,
    platform: CreatorSocialPlatformId,
): boolean {
    return isBrandPlatformAutoLinkEnabled(config, platform);
}

export function influencerPlatformManualLabels(platform: CreatorSocialPlatformId): {
    usernameLabel: string;
    followersLabel: string;
} {
    if (platform === 'youtube') {
        return { usernameLabel: 'Channel name', followersLabel: 'Total subscribers' };
    }
    return { usernameLabel: 'Username', followersLabel: 'Total followers' };
}

export function influencerPlatformSaveLabel(platform: CreatorSocialPlatformId): string {
    const name = platform === 'instagram' ? 'Instagram' : platform === 'tiktok' ? 'TikTok' : 'YouTube';
    return `Save ${name} profile`;
}

/** Guests may only connect Instagram until they sign in; logged-in users can connect any platform. */
export function canConnectAllCreatorPlatforms(isSignedIn: boolean): boolean {
    return isSignedIn;
}

export function isCreatorPlatformLockedForGuest(
    platform: CreatorSocialPlatformId,
    isSignedIn: boolean,
    connected: boolean,
): boolean {
    return !isSignedIn && platform !== 'instagram' && !connected;
}
